import React from 'react'

export default function BillBalloon({ data }) {
    return (
        <div className='px-3'>
            <div className='px-3'>
                <div className='d-flex justify-content-between mb-3'>
                    <div>Tagihan Pokok</div>
                    <div>{data?.bill?.loanAmount}</div>
                </div>
                <div className='d-flex justify-content-between mb-3'>
                    <div>Denda Keterlambatan</div>
                    <div>{data?.bill?.lateCharge}</div>
                </div>
                <div className='d-flex justify-content-between mb-3'>
                    <div>Simpan & Asuransi Keterlambatan</div>
                    <div>{data?.bill?.savingLateCharge}</div>
                </div>
            </div>
            <div style={{ padding: 12, backgroundColor: 'rgba(44, 70, 92, 0.14)', borderRadius: 10 }} className="d-flex justify-content-between">
                <div style={{ fontSize: 18, fontWeight: '500' }}>
                    Total Tagihan yang Harus Dibayarkan
                </div>
                <div style={{ fontWeight: '700' }} className="text-bold">
                    {data?.bill?.total}
                </div>
            </div>
        </div>
    )
}
